import React, {useState}   from 'react';

import { NavLink } from "react-router-dom";
import { Collapse, Button } from "reactstrap";

var Utils = require ('Utils');
var Const = require ('Const');

export const  UserSidebar = ( { user, logout } ) => {

    const [ openAvatar, isOpenAvatar] = useState(false);

    return (
    <div className="user">
            <div className="photo">

              <img src={user.image?user.image:Const.DEFAULT_IMAGE_PROFILE[(user.gender?user.gender:'O')]} alt="Avatar" />
            </div>
            <div className="info">
              <a
                href="#inicio"
                data-toggle="collapse"
                aria-expanded={openAvatar}
                onClick={() => isOpenAvatar(!openAvatar)
                }
              >
                <span>
                  {Utils.capitalize(user.name + " " + user.last_name)}
                  <b className="caret" />
                </span>
              </a>
              
              {/* Options  */}
              {!user.image &&
                  <div className="alert-text alert "// alert-danger" 
                     style={{margin: "15px",  backgroundColor: "#ff5757", color: "#000000"}} >
                  {user.name}, aún NO cargaste la foto de perfil. <b>Es necesario lo hagas</b>. 
                  <Button><a href="/admin/my-profile" >Completar</a></Button>
                </div>
               }
              <Collapse isOpen={openAvatar}>
                <ul className="nav">
                  <li>
                    <NavLink to={"/admin/my-profile"} activeClassName="">
                      <span className="sidebar-mini-icon">MD</span>
                      <span className="sidebar-normal">Mis Datos</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink onClick={logout} to="/" activeClassName="">
                      <span className="sidebar-mini-icon">S</span>
                      <span className="sidebar-normal">Salir</span>
                    </NavLink>
                  </li> 

                             

                </ul>
              </Collapse>
            </div>
          </div>
      );
    }
          